import Downshift from 'downshift';
import PropTypes from 'prop-types';
import cn from 'classnames';

import style from './Select.module.css';

const Select = ({
  formik,
  label,
  name,
  containerStyle,
  items,
  initialSelectedIndex = null,
  placeholder,
}) => {
  const hasError = formik.errors[name] && formik.touched[name];

  return (
    <Downshift
      initialSelectedItem={
        initialSelectedIndex !== null ? items[initialSelectedIndex] : null
      }
      onChange={(selection) => {
        formik.setFieldValue(name, selection);
      }}
      itemToString={(item) => (item ? item.value : '')}
    >
      {({
        getItemProps,
        getLabelProps,
        getMenuProps,
        isOpen,
        selectedItem,
        getToggleButtonProps,
      }) => (
        <div
          className={cn(
            style.container,
            containerStyle,
            hasError && style.selectError
          )}
        >
          <label
            className={cn(style.label, hasError && style.labelError)}
            {...getLabelProps()}
          >
            {label}
          </label>
          <button
            className={cn(style.selectBtn, isOpen && style.selectBtnOpen)}
            type="button"
            {...getToggleButtonProps()}
          >
            <span>{selectedItem ? selectedItem.value : placeholder}</span>
          </button>
          <ul
            className={isOpen ? style.list : style.listHide}
            {...getMenuProps()}
          >
            {isOpen
              ? items.map((item, index) => (
                  <li
                    key={index}
                    className={style.listItem}
                    {...getItemProps({
                      key: item.value,
                      index,
                      item,
                      style: {
                        fontWeight: selectedItem === item ? 'bold' : 'normal',
                        background: selectedItem === item ? '#FFD300' : 'white',
                      },
                    })}
                  >
                    {item.value}
                  </li>
                ))
              : null}
          </ul>
          <span id={`form-${name}`} className={cn(style.error)}>
            {hasError ? formik.errors[name] : ''}
          </span>
        </div>
      )}
    </Downshift>
  );
};

Select.propTypes = {
  formik: PropTypes.object,
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  containerStyle: PropTypes.string,
  items: PropTypes.array.isRequired,
  initialSelectedIndex: PropTypes.number,
  placeholder: PropTypes.string,
};

export default Select;
